<template>
  <div class="card">
    <header class="bandeau-modal card-header">
    </header>
    <app-consulter-reglement v-if="etatActuel"
                             :intervenant="intervenant"
                             :afficherDelai="afficherDelai"
                             @modifier="etatActuel = false"
                             :isPaiement="isPaiement"
                             @close="$parent.close()"/>
    <app-modifier-reglement v-else
                            :afficherDelai="afficherDelai"
                            :etat="etat"
                            :isPaiement="isPaiement"
                            @close="$parent.close()"
                            @enregistrer="enregistrer"
                            :intervenant="intervenant"/>
  </div>
</template>

<script>
import ConsulterReglement from './consulterReglement';
import ModifierReglement from './modifierReglement';

export default {
  name: 'DevisCommandesEditReglement',
  props: {
    etat: {
      required: false,
      type: Boolean,
    },
    intervenant: {
      type: Object,
      required: true,
    },
    afficherDelai: {
      type: Boolean,
      required: false,
      default: true,
    },
    isPaiement: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      etatActuel: null,
    };
  },
  components: {
    appConsulterReglement: ConsulterReglement,
    appModifierReglement: ModifierReglement,
  },
  methods: {
    enregistrer(value) {
      this.$emit('enregistrer', value);
      this.$parent.close();
    },
  },
  mounted() {
    this.etatActuel = this.etat;
  },
};
</script>

<style scoped>

</style>
